<template>
    <div class="py-3">
        <v-row class="d-none">
            <v-col cols="12" class="pb-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.pharmacy_sites"
                    :label="t('pharmacy-groups::form.label.pharmacy_sites')"
                    :select-items="selectedPharmacySites"
                    :readonly="true"
                    rounded
                    mandatory
                    class="d-none"
                ></b-input>
            </v-col>
        </v-row>
        <pharmacy-group-pharmacy-site-data-table :list-route="sitesListRoute" :disabled="readOnlyRules">
        </pharmacy-group-pharmacy-site-data-table>
    </div>
</template>

<script>
export default {
    props: {
        sitesListRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            filters: {
                site_name: null,
                dms_id: null,
                registered: null,
            },
            registered_filters: [
                { label: t('pharmacy-sites::label.all'), value: null },
                { label: t('pharmacy-sites::label.yes'), value: 1 },
                { label: t('pharmacy-sites::label.no'), value: 0 },
            ],
            readOnlyRules: !this.can('api.v1.pharmacy-groups.update') && this.can('api.v1.pharmacy-groups.show'),
            validationRules: {
                pharmacy_sites: [(v) => (!!v && !!v.length) || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        id() {
            return this.$store.state.pharmacy_groups.pharmacy_group.id;
        },
        // pharmacyGroupOptions() {
        //     return this.$store.state.pharmacy_groups.pharmacyGroupOptions;
        // },
        bloodProvidersOptions() {
            return this.$store.state.pharmacy_groups.bloodProvidersOptions;
        },
        selectedPharmacySites: {
            get() {
                return this.$store.state.pharmacy_groups.pharmacy_group.pharmacy_sites;
            },
            set(value) {
                this.$store.dispatch(`pharmacy_groups/updateProperty`, {
                    value: value,
                    property: 'pharmacy_group.pharmacy_sites',
                });
            },
        },
    },
    methods: {
        resetFilters() {
            if (!this.$refs.filterForm) {
                return this.fetchNewPharmacyOptions();
            }
            this.$refs.filterForm.reset();
            this.fetchNewPharmacyOptions();
        },
        fetchNewPharmacyOptions() {
            this.$store.dispatch('pharmacy_groups/loadPharmacyOptions', this.filters);
        },
        async save() {
            this.$store.dispatch('pharmacy_groups/resetErrorMessages');

            axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.pharmacy-groups.update', { pharmacy_group: this.id })
                    : route('api.v1.pharmacy-groups.store'),
                data: this.$store.state.pharmacy_groups.pharmacy_group,
            })
                .then(() => {
                    this.$root.notify('info', t('default::notification.saved'));
                    if (!this.id) {
                        this.$root.goTo(route('pharmacy-groups.index'));
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('pharmacy_groups/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                });
        },
    },
};
</script>

<style></style>
